import React, { useState, useEffect } from "react";
import { Form, Button, Checkbox, Message } from "semantic-ui-react";
import { useFormik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { useAuth } from "../../../../hook/userAuth";
import { ToastContainer } from "react-toastify";
import { BASE_API } from "../../../../ruta-server/BaseApi";
import "react-toastify/dist/ReactToastify.css";

export function ListaAlumnosTraslado(props) {
  const { onRefetch, id_curso, ids_alumnosFaltantes, onClose } = props;
  const { auth } = useAuth();
  const [selectedAlumnos, setSelectedAlumnos] = useState([]);
  const [selectAll, setSelectAll] = useState(false);
  const [alumnos, setAlumnos] = useState([]);
  const [loading, setLoading] = useState(true);

  async function getAlumnosApi() {
    try {
      const promises = ids_alumnosFaltantes.map((id) =>
        axios.get(`${BASE_API}/api/alumno/${id}/`, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        })
      );
      const responses = await Promise.all(promises);
      const result = responses.map((response) => response.data);
      setAlumnos(result);
      setLoading(false);
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  async function addAlumnoCurso() {
    try {
      const promises = selectedAlumnos.map(async (alumnoId) => {
        const data = {
          curso: id_curso,
          alumno: alumnoId,
        };
        return axios.post(`${BASE_API}/api/calificacion_curso/`, data, {
          headers: {
            Authorization: `Bearer ${auth.token}`,
          },
        });
      });
      const responses = await Promise.all(promises);
      const results = responses.map((response) => response.data);
      return results;
    } catch (error) {
      setLoading(false);
      window.location.reload();
      window.location.href = "/Login";
    }
  }

  useEffect(() => {
    if (ids_alumnosFaltantes && ids_alumnosFaltantes.length > 0) {
      setLoading(true);
      getAlumnosApi();
    }
  }, [ids_alumnosFaltantes]);

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    if (!selectAll) {
      setSelectedAlumnos(alumnos.map((alumno) => alumno.id));
    } else {
      setSelectedAlumnos([]);
    }
  };

  const handleSelectAlumno = (id) => {
    if (selectedAlumnos.includes(id)) {
      setSelectedAlumnos(selectedAlumnos.filter((alumnoId) => alumnoId !== id));
    } else {
      setSelectedAlumnos([...selectedAlumnos, id]);
    }
  };

  const formik = useFormik({
    initialValues: initialValues(),
    validationSchema: Yup.object(newSchema()),
    validateOnChange: false,
    onSubmit: async () => {
      await addAlumnoCurso();
      onClose();
      onRefetch();
    },
  });

  return (
    <>
      {alumnos.length === 0 ? (
        <Message
          info
          header="Todos los alumnos de traslado están inscritos en el curso"
          content="No hay alumnos de traslado por inscribir."
        />
      ) : (
        <Form className="add-edit-user-form" onSubmit={formik.handleSubmit}>
          <Form.Field>
            <Checkbox
              label="Seleccionar a todos"
              checked={selectAll}
              onChange={handleSelectAll}
            />
          </Form.Field>

          {alumnos.map((alumno, index) => (
            <Form.Field key={index}>
              <Checkbox
                name="alumno"
                error={formik.errors.alumno}
                label={`${alumno.nombre} ${alumno.apellido_paterno} ${
                  alumno.apellido_materno
                } - 
                ${
                  alumno.matricula
                    ? `Matrícula: ${alumno.matricula}`
                    : `CURP: ${alumno.curp}`
                }`}
                checked={selectedAlumnos.includes(alumno.id)}
                onChange={() => handleSelectAlumno(alumno.id)}
              />
            </Form.Field>
          ))}
          <Button
            type="submit"
            content={"Añadir al curso"}
            style={{ backgroundColor: "#008e86", color: "white" }}
            fluid
          />
        </Form>
      )}
      <ToastContainer />
    </>
  );
}

function initialValues() {
  return {};
}

function newSchema() {
  return {};
}
